import * as R from 'ramda'
import uuidv4 from '@/utilities/uuid.js'
import api from '@/api'
import { successPipeline } from '@/api/pipelines/success-pipeline.js'

const otherIncomeItemPresenter = (otherIncomeItem, itemId) => {
  return {
    id: itemId,
    description: otherIncomeItem['description'],
    price: otherIncomeItem['price'],
    defaultQuantity: otherIncomeItem['defaultQuantity']
  }
}

const state = {
  otherIncomeItems: {}
}

const mutations = {
  LOAD_OTHER_INCOME_ITEMS (state, payload) {
    state.otherIncomeItems = payload
  },

  UPDATE_OTHER_INCOME_ITEM (state, { id, item }) {
    state.otherIncomeItems[id] = item
  },

  ADD_OTHER_INCOME_ITEM (state, { id, item }) {
    const items = {
      ...state.otherIncomeItems,
      [id]: item
    }

    state.otherIncomeItems = items
  },

  DELETE_OTHER_INCOME_ITEM (state, payload) {
    state.otherIncomeItems = R.omit(payload, state.otherIncomeItems)
  }
}

const actions = {
  updateOtherIncomeItem ({ commit, getters }, jsConn) {
    if (jsConn.formParams.id === 'new') {
      const id = uuidv4()
      jsConn.formParams = {
        id: id,
        item: jsConn.formParams.item
      }

      if (getters.signedIn) {
        return api.createOtherIncome(jsConn)
          .then(jsConn => {
            return successPipeline(jsConn)
          })
          .then(jsConn => {
            jsConn.toastMessage = jsConn.formParams['item']['description'] + ' successfully saved'
            commit('ADD_OTHER_INCOME_ITEM', jsConn.formParams)
            return Promise.resolve(jsConn)
          })
          .catch(jsConn => {
            jsConn.toastMessage = 'Unable to save ' + jsConn.formParams['item']['description']
            return Promise.reject(jsConn)
          })
      } else {
        jsConn.toastMessage = jsConn.formParams['item']['description'] + ' successfully saved for this browser session'
        commit('ADD_OTHER_INCOME_ITEM', jsConn.formParams)
        return Promise.resolve(jsConn)
      }
    } else {
      if (getters.signedIn) {
        return api.updateOtherIncome(jsConn)
          .then(jsConn => {
            return successPipeline(jsConn)
          })
          .then(jsConn => {
            commit('UPDATE_OTHER_INCOME_ITEM', jsConn.formParams)
            jsConn.toastMessage = jsConn.formParams['item']['description'] + ' successfully updated'
            return Promise.resolve(jsConn)
          })
          .catch(jsConn => {
            return Promise.reject(jsConn)
          })
      } else {
        commit('UPDATE_OTHER_INCOME_ITEM', jsConn.formParams)
        jsConn.toastMessage = jsConn.formParams['item']['description'] + ' successfully updated for this browser session'
        return Promise.resolve(jsConn)
      }
    }
  },

  deleteOtherIncomeItem ({ commit, getters, dispatch }, jsConn) {
    if (getters.signedIn) {
      return api.deleteOtherIncome(jsConn)
        .then((jsConn) => {
          return successPipeline(jsConn)
        })
        .then(jsConn => {
          dispatch('deleteOtherIncomeItemFromAllCrops', jsConn)
          commit('DELETE_OTHER_INCOME_ITEM', [jsConn.formParams['id']])
          jsConn.toastMessage = 'Other income item deleted'
          return Promise.resolve(jsConn)
        })
        .catch(jsConn => {
          jsConn.toastMessage = 'Unable to delete item'
          return Promise.reject(jsConn)
        })
    } else {
      dispatch('deleteOtherIncomeItemFromAllCrops', jsConn)
      commit('DELETE_OTHER_INCOME_ITEM', [jsConn.formParams['id']])
      jsConn.toastMessage = 'Other income item deleted for this browser session'
      return Promise.resolve(jsConn)
    }
  }
}

const getters = {
  otherIncomeItems: state => state.otherIncomeItems,

  otherIncomeItemsIdList: state => {
    return Object.keys(state.otherIncomeItems)
  },

  otherIncomeItemsList: (state, getters) => {
    const itemsList = R.map((itemId) => {
      const item = getters.getOtherIncomeItemById(itemId)
      return otherIncomeItemPresenter(item, itemId)
    }, getters.otherIncomeItemsIdList)

    return itemsList
  },

  getOtherIncomeItemById: (state) => (id) => {
    return state.otherIncomeItems[id]
  }
}

const otherIncomeModule = {
  state,
  mutations,
  actions,
  getters
}

export default otherIncomeModule
